export const longGrassLengthCutoffInInches = {
    fee: 9,
    quote: 15,
};

export const OTHER_LG_REASON = 'customer.lg.other';
export const GRASS_NOT_OVER_6IN = 'grass_not_over_6in';
export const GRASS_NOT_OVER_9IN = 'grass_not_over_9in';
export const SERVICE_DELAYS_LED_TALL_GRASS = 'service_delays_led_tall_grass';
export const CUSTOMER_UNAWARE_OF_LG_POLICY = 'customer.lg.unaware_of_policy';
export const PICTURES_NOT_FROM_PROPERTY = 'customer.pictures_not_from_property';

export const longGrassDisputeReasons = [
    {
        reason: { value: GRASS_NOT_OVER_9IN, label: 'Grass was not over 9" tall' },
        details: [
            { value: 'all_area_under_9in', label: 'All of the area was under 9"' },
            { value: 'most_area_under_9in', label: 'Most of the area was under 9"' },
            { value: 'some_area_under_9in', label: 'Some of the area was under 9"' },
        ],
    },
    {
        reason: {
            value: SERVICE_DELAYS_LED_TALL_GRASS,
            label: 'Service delays led to tall grass',
        },
        details: [
            { value: 'cust_skipped_last_service', label: 'I skipped the last service' },
            { value: 'pro_skipped_last_service', label: 'My pro skipped the last service' },
            { value: 'weather_delayed', label: 'Weather delayed mowing' },
            { value: 'not_showed_for_last_service', label: 'No one showed for my last service' },
        ],
    },
    { value: CUSTOMER_UNAWARE_OF_LG_POLICY, label: "Didn't know about long grass fee" },
    { value: PICTURES_NOT_FROM_PROPERTY, label: 'Pictures are not from my property' },
    { value: OTHER_LG_REASON, label: 'Other' },
];

export const getLongGrassPolicy = () => {
    const { fee, quote } = longGrassLengthCutoffInInches;

    return [
        'We highly value the time and equipment of our providers, and in doing so, reserve the right to charge a fee of up to 100% of your normal rate for cutting an overgrown yard.',
        `Why is there a premium? An overgrown yard (over ${fee} inches) may take longer to complete and longer grass will put more strain on the equipment.`,
        `If your yard is very overgrown (over ${quote} inches), we will provide you with a custom quote for the service necessary to get the grass down to a more manageable length.`,
    ];
};

export const getLongGrassPricingConcepts = () => {
    const { fee } = longGrassLengthCutoffInInches;

    return [
        {
            title: '1 Grass height',
            description: `If grass height exceeds ${fee} inches, the long grass fee multiplies the original service fee based on the height of the grass. The taller the grass, the higher the fee.`,
            images: {
                bad: 'long-grass/image/height-not-ok.jpg',
                good: 'long-grass/image/height-ok.jpg',
            },
        },
        {
            title: '2 Long grass area in the yard',
            description:
                'Sometimes only part of the service area will be covered with long grass. If the long grass area is partial (less than half the service area), the additional fee is half what it would be for the full area.',
            images: {
                bad: 'long-grass/image/scope-not-ok.jpg',
                good: 'long-grass/image/scope-ok.jpg',
            },
        },
        {
            title: '3 Special requirement',
            description:
                'If cutting the grass requires extra time, different equipment, or some other special requirement due to its thickness, the fee increases another 50% based on the grass height and area.',
            images: {
                bad: 'long-grass/image/reqs-not-ok.jpg',
                good: 'long-grass/image/reqs-ok.jpg',
            },
        },
    ];
};
